export const AUTH_CHANNEL = 'auth_channel';
export const INITIAL_HANDSHAKE = 'initial_handshake';
export const AUTH_SYNC_VERSION = 1;
export const NOTION_USER_ID_KEY = 'notion_user_id';
export const AUTH_STORAGE_KEY = 'auth_sync_message';
